import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faXmark, faFileExcel} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addSubscription } from '../../Service';
import { setToken,setUserData } from '../../reducers/User/action';
import { useDispatch} from 'react-redux'


export default function CreateSubscription(){
    const submitSuccess =false;

    
    const dispatch=useDispatch();
    const navigation = useNavigate();
    const initialValues = { sub_name: "", sub_validity: "", sub_price: "", status: "" };
    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});


    const hanldeChange = (e) => {
        const value=e.target.value;
        const field=e.target.name;
        setFormValues(prevState => ({
        ...prevState,
        [field]: value }));
    }


		const handleSubmit = (e) => {
			e.preventDefault();
            console.log(formValues);
			const errorCount = validate(formValues);
			setFormErrors(errorCount);
            console.log(errorCount.status);
       
 
			if(errorCount.status){

				var bodyFormData = formValues;
                 console.log(bodyFormData);

                 addSubscription(bodyFormData).then(res => handleResponse(res))

            }else{
				window.scrollTo(100, 100);
				return false;
			}
		}


        const handleResponse = (response) => {
            if(response.data.code==400){ //IF Token Expired......
                const errors = {};
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: response.data.message,
                })
                errors.status = false;
                setFormErrors(errors);
              }else if(response.data.code==200){  //IF Request is Success
                const myinfo=[];
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Subscription Added Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                  })
                navigation("/admin-subscription");
              }
          }

		const validate = (values) => {
			const errors = {};
			errors.status = true;

			if(!values.sub_name){
				errors.sub_name = 'Subscription Name is required';
				errors.status = false;
			}

            if(!values.sub_validity){
				errors.sub_validity = 'Subscription Duration is required';
				errors.status = false;
			}

            if(!values.sub_price){
				errors.end_date = 'Subscription Price is required';
				errors.status = false;
			}

			return errors;
		}

 return(
<section className="admin-section">
<div className="container">
<div className="row">
<div className="col-md-12 col-12">
<div className="admin-edit">
<h1>ADD SUBSCRIPTION DETAILS</h1>
<Form onSubmit={handleSubmit} className="event-form">
    <Form.Group>
        <Form.Label>Name <span className='star'>*</span></Form.Label>
        <Form.Control type="text" name="sub_name" defalutValue={formValues.sub_name} placeholder="Subscription Name" onChange={hanldeChange} />
        <p className="error">{formErrors.sub_name}</p>
    </Form.Group>
<Row>
    <Col>
    <Form.Group>
        <Form.Label>Duration<span className='star'>*</span></Form.Label>
        <Form.Select aria-label="Default select example" defalutValue={formValues.sub_validity} name="sub_validity" onChange={hanldeChange} >
        <option value="">-- Choose Duration --</option>
        <option value="1">Annually</option>
        <option value="2">Half-Yearly</option>
        <option value="3">Quarterly</option>
        <option value="4">Monthly</option>
        </Form.Select>
        <p className="error">{formErrors.sub_validity}</p>
    </Form.Group>
    </Col>
    <Col>
    <Form.Group controlId="enddate">
        <Form.Label>Price in USD<span className='star'>*</span></Form.Label>
        <Form.Control type="text" name="sub_price" defalutValue={formValues.sub_price} placeholder="Subscription Price" onChange={hanldeChange} />
        <p className="error">{formErrors.end_date}</p>
    </Form.Group>
    </Col>
</Row>

<hr/>


    <Button variant="primary" type="submit" className='submit' onClick={handleSubmit} >
        Add
    </Button>
</Form>
</div>
</div>
</div>
</div>
</section>
)
}